import React from "react";

const ToggleOption = ({ active, onClick, icon, label }) => (
  <div
    className={`flex-fill p-2 border rounded text-center ${active ? "border-primary bg-light" : "bg-white"}`}
    style={{ cursor: "pointer", transition: "all 0.2s" }}
    onClick={onClick}
  >
    <div className="fw-medium small">
      <i className={`fas ${icon} me-2`}></i>{label}
    </div>
  </div>
);

export default ToggleOption;
